import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { render } from 'react-dom';

import theme from '../../../ts/theme';
import ErrorBoundary from '../../components/ErrorBoundary';
import onDomContentLoaded from '../../utilities/onDomContentLoaded';
import BuyWithConfidence from './components/BuyWithConfidence';
import FAQ from './components/FAQ';
import Hero from './components/Hero';
import Steps from './components/Steps';

import '../../../scss/pages/buying-online/main.scss';
import BuyingOnlineDisclaimer from './components/BuyingOnlineDisclaimer';
import ReadyToFind from './components/ReadyToFind';

const BuyingOnline = () => (
    <>
        <Hero />
        <Steps />
        <BuyWithConfidence />
        <FAQ />
        <ReadyToFind />
        <BuyingOnlineDisclaimer />
    </>
);

function startup() {
    const buyingOnlineContainer = document.getElementById('buying-online-container');
    if (!buyingOnlineContainer) return;

    render(
        <ErrorBoundary>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <BuyingOnline />
            </ThemeProvider>
        </ErrorBoundary>,
        buyingOnlineContainer,
    );
}

onDomContentLoaded(startup);
